//
import endpoints from '../endpoints';
import WebMethodService from '../WebMethodService';

class PublicCustomAPI {
  /**
   * Restituisce configurazione di azione per idList e actionCode
   * @param {number} idList 
   * @param {string} actionCode 
   * @returns {Promise}
   * 
   */
  static getAction(idList, actionCode) {
    const params = {
      idList,
      actionCode
    };
    return WebMethodService.callWebMethod(endpoints.publicCustom.getAction, params);
  }

  /**
   * Restituisce configurazione di azione per idList e actionCode
   * @param {number} idList 
   * @param {string} actionCode 
   * @returns {Promise}
   * 
   */
  static getActionForRecipient(idList, actionCode, email, preview) {
    const params = {
      idList,
      actionCode,
      email,
      preview
    };
    return WebMethodService.callWebMethod(endpoints.publicCustom.getActionForRecipient, params);
  }


  /**
   * Restituisce configurazione messaggio per idList e actionCode
   * @param {number} idList 
   * @param {string} actionCode 
   * @returns {Promise}
   * 
   */
  static getText(idList, actionCode) {
    const params = {
      idList,
      actionCode
    };
    return WebMethodService.callWebMethod(endpoints.publicCustom.getText, params);
  }

  /**
   * Restituisce configurazione di lista dato  idList
   * @param {number} idList 
   * @returns {Promise}
   * 
   */
  static getSettings(idList) {
    const params = {
      idList
    };
    return WebMethodService.callWebMethod(endpoints.publicCustom.getSettings, params);
  }

  /**
   * Restituisce GUID di lista dato  idList
   * @param {number} idList 
   * @returns {Promise}
   * 
   */
  static getListGUID(idList) {
    const params = {
      idList
    };
    return WebMethodService.callWebMethod(endpoints.publicCustom.getListGUID, params);
  }

  /**
   * Restituisce IP del client
   * @returns {Promise}
   * 
   */
  static getClientIP() {
    return WebMethodService.callWebMethod(endpoints.publicCustom.getClientIP, {});
  }

  static getCustomFlowConfig(idCustomFlowConfig) {
    return WebMethodService.callWebMethod(endpoints.publicCustom.getCustomFlowConfig, {
      idCustomFlowConfig
    });
  }

}

export default PublicCustomAPI;